export const paths = {
  jobEditor: (jobId: string): string => `/jobs/${jobId}/edit`,
};
